<template>
  <MainLayout selectMenu="1-1" siderMenu="15-1" sideBar="machine">
    <div v-if="!hasAuth">
      <NoAuth></NoAuth>
    </div>
    <div v-else>      
      <Row class="menu-line" type="flex">
         <Col flex="2" class="menu-actions" v-if="record && record.length > 0">
        <Button type="error" size="small" icon="md-trash" @click.native="deleteRecord()">{{ getTranslation("m027") }}</Button>&nbsp;
        <Button type="info" size="small" icon="md-cloud-download" @click.native="exportRecord">{{ getTranslation("k025") }}</Button>
        </Col>
        <Col flex="12" class="search-part">
          <Button type="info" size="small" icon="md-funnel" @click="colShowVisible = true">{{ getTranslation('u113') }}</Button>&nbsp;
        {{ getTranslation('k221') }}:&nbsp;<DatePicker size="small" transfer type="daterange" placement="bottom-end"
          :placeholder="getTranslation('k220')" style="width: 210px" v-model="selectDate" format="yyyy-MM-dd">
        </DatePicker>&nbsp;
        <Select style="width:100px" size="small" :transfer="true" v-model="alarmOpt" class="input-field"
          :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
          <Option v-for="(item, key) in WarnList" :value="key" :key="key">{{ item }}</Option>
        </Select>&nbsp;
        <Input v-model="programId" @on-enter="queryData()" size="small" style="width:100px" :placeholder="getTranslation('b006')" />&nbsp;
        <Input v-model="vin" @on-enter="queryData()" size="small" style="width:120px" :placeholder="getTranslation('k226')" />&nbsp;
        <Input v-model="spotId" @on-enter="queryData()" size="small" style="width:120px" :placeholder="getTranslation('k259')" />&nbsp;
        <Input v-model="recordId" @on-enter="queryData()" size="small" style="width:260px" :placeholder="getTranslation('r105')" />&nbsp;
        {{getTranslation('k235')}}:&nbsp;<Input v-model="uipStart" @on-enter="queryData()" size="small" style="width:40px"  />&nbsp;-&nbsp;
        <Input v-model="uipEnd" @on-enter="queryData()" size="small" style="width:40px"  />&nbsp;
        <Tooltip :content="getTranslation('k176')" placement="bottom" theme ="light" :transfer="true">
        <Button type="primary" size="small" @click.native="queryData()" shape="circle" icon="ios-search"></Button></Tooltip>&nbsp;
        <Tooltip :content="getTranslation('e020')" placement="bottom" theme ="light" :transfer="true">
        <Button type="error" size="small"  @click.native="emptyRecordQuery()" shape="circle"
                            icon="ios-refresh"></Button></Tooltip>
        </Col>
      </Row>
      <Affix>
      <Row class="table-header" type="flex" style="flex-wrap: nowrap;overflow: visible !important;">
        <Col flex="2" class="table-cell flex-left" :style="colStyle('1')" ref="col-ref-1" v-show="showCol('1')">
          &nbsp;<Checkbox @on-change="handleCheckAll"></Checkbox>{{ getTranslation('k221') }}
          <span class="col-resizer" @mousedown="startResize('1', $event)"></span>
        </Col>
        <Col flex="2" class="table-cell" :style="colStyle('2')" ref="col-ref-2" v-show="showCol('2')">
          {{ getTranslation('k226') }}<span class="col-resizer" @mousedown="startResize('2', $event)">&nbsp;</span>
        </Col>
        <Col flex="2" class="table-cell" :style="colStyle('3')" ref="col-ref-3" v-show="showCol('3')">
          {{ getTranslation('k258') }}<span class="col-resizer" @mousedown="startResize('3', $event)"></span>
        </Col>
        <Col flex="2" class="table-cell" :style="colStyle('4')" ref="col-ref-4" v-show="showCol('4')">
          {{ getTranslation('k259') }}<span class="col-resizer" @mousedown="startResize('4', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('5')" ref="col-ref-5" v-show="showCol('5')">
          {{ getTranslation('b006') }}<span class="col-resizer" @mousedown="startResize('5', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('6')" ref="col-ref-6" v-show="showCol('6')">
          {{ getTranslation('k243') }}<span class="col-resizer" @mousedown="startResize('6', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('7')" ref="col-ref-7" v-show="showCol('7')">
          {{ getTranslation('k244') }}<span class="col-resizer" @mousedown="startResize('7', $event)"></span>
        </Col>
        <Col flex="2" class="table-cell" :style="colStyle('8')" ref="col-ref-8" v-show="showCol('8')">
          {{ getTranslation('k241') }}<span class="col-resizer" @mousedown="startResize('8', $event)"></span>
        </Col>
        <Col flex="2" class="table-cell" :style="colStyle('9')" ref="col-ref-9" v-show="showCol('9')">
          {{ getTranslation('k213') }}<span class="col-resizer" @mousedown="startResize('9', $event)"></span>
        </Col>
        <Col flex="2" class="table-cell" :style="colStyle('10')" ref="col-ref-10" v-show="showCol('10')">
          {{ getTranslation('k172') }}<span class="col-resizer" @mousedown="startResize('10', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('11')" ref="col-ref-11" v-show="showCol('11')">
          {{ getTranslation('k173') }}<span class="col-resizer" @mousedown="startResize('11', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('12')" ref="col-ref-12" v-show="showCol('12')">
          {{ getTranslation('b007') }}<span class="col-resizer" @mousedown="startResize('12', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('13')" ref="col-ref-13" v-show="showCol('13')">
          {{ getTranslation('k227') }}<span class="col-resizer" @mousedown="startResize('13', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('14')" ref="col-ref-14" v-show="showCol('14')">
          {{ getTranslation('k228') }}<span class="col-resizer" @mousedown="startResize('14', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('15')" ref="col-ref-15" v-show="showCol('15')">
          {{ getTranslation('k229') }}<span class="col-resizer" @mousedown="startResize('15', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('16')" ref="col-ref-16" v-show="showCol('16')">
          {{ getTranslation('k230') }}<span class="col-resizer" @mousedown="startResize('16', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('17')" ref="col-ref-17" v-show="showCol('17')">
          {{ getTranslation('k231') }}<span class="col-resizer" @mousedown="startResize('17', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('18')" ref="col-ref-18" v-show="showCol('18')">
          {{ getTranslation('k232') }}<span class="col-resizer" @mousedown="startResize('18', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('19')" ref="col-ref-19" v-show="showCol('19')">
          {{ getTranslation('k233') }}<span class="col-resizer" @mousedown="startResize('19', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('20')" ref="col-ref-20" v-show="showCol('20')">
          {{ getTranslation('k234') }}<span class="col-resizer" @mousedown="startResize('20', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('21')" ref="col-ref-21" v-show="showCol('21')">
          {{ getTranslation('k235') }}<span class="col-resizer" @mousedown="startResize('21', $event)"></span>
        </Col>
        <Col flex="1" class="table-cell" :style="colStyle('22')" ref="col-ref-22" v-show="showCol('22')">
          {{ getTranslation('b176') }}<span class="col-resizer" @mousedown="startResize('22', $event)"></span>
        </Col>
      </Row>
    </Affix>
    <CheckboxGroup v-model="selectedItems">
      <Row v-for="(item,index) in record" :class="['table-row', index % 2 === 0 ? 'table-row-even' : 'table-row-odd']" :key="uniqLabel(item)" 
      style="flex-wrap: nowrap;overflow: visible !important;" type="flex">
        <Col flex="2" class="table-cell" :style="colStyle('1')" v-show="showCol('1')">
          &nbsp;<Checkbox class="hide-label" :label="uniqLabel(item)"></Checkbox>
          &nbsp;{{ formatShorTime(item.created_string) }}
        </Col>
        <Col flex="2" class="table-cell" :style="colStyle('2')" v-show="showCol('2')">{{ item.Vin }}</Col>
        <Col flex="2" class="table-cell" :style="colStyle('3')" v-show="showCol('3')">{{ item.SpotModel }}</Col>
        <Col flex="2" class="table-cell" :style="colStyle('4')" v-show="showCol('4')">{{ item.SpotIdString }}</Col>
        <Col flex="1" class="table-cell" :style="colStyle('5')" v-show="showCol('5')">{{ item.NoWeldProgram }}</Col>
        <Col flex="1" class="table-cell" :style="colStyle('6')" v-show="showCol('6')">{{ item.SpotPss }}</Col>
        <Col flex="1" class="table-cell" :style="colStyle('7')" v-show="showCol('7')">{{ item.SpotThk }}</Col>
        <Col flex="2" class="table-cell" :style="colStyle('8')" v-show="showCol('8')">{{ item.SpotName }}</Col>
        <Col flex="2" class="table-cell" :style="colStyle('9')" v-show="showCol('9')">{{ item.PartName }}</Col>
        <Col flex="2" class="table-cell" :style="colStyle('10')" v-show="showCol('10')">{{ item.BatchNumber }}</Col>
        <Col flex="1" class="table-cell" :style="colStyle('11')" v-show="showCol('11')">{{ item.Worker }}</Col>
        <Col flex="1" class="table-cell" :style="colStyle('12')" v-show="showCol('12')">{{ item.WeldProgram }}</Col>
        <Col flex="1" class="table-cell" :style="colStyle('13')" v-show="showCol('13')">{{ item.CrrWeld1 }} / {{ item.TimWeld1 }}</Col>
        <Col flex="1" class="table-cell" :style="colStyle('14')" v-show="showCol('14')">{{ item.CrrWeld2 }} / {{ item.TimWeld2 }}</Col>
        <Col flex="1" class="table-cell" :style="colStyle('15')" v-show="showCol('15')">{{ item.CrrWeld3 }} / {{ item.TimWeld3 }}</Col>
        <Col flex="1" class="table-cell" :style="colStyle('16')" v-show="showCol('16')">{{ item.ValCurrentGun }}</Col>
        <Col flex="1" class="table-cell" :style="colStyle('17')" v-show="showCol('17')">{{ item.ValPowerCnt }}</Col>
        <Col flex="1" class="table-cell" :style="colStyle('18')" v-show="showCol('18')">{{ item.ValDutyOnTime }}</Col>
        <Col flex="1" class="table-cell" :style="colStyle('19')" v-show="showCol('19')">{{ item.ValSecVolt }}</Col>
        <Col flex="1" class="table-cell" :style="colStyle('20')" v-show="showCol('20')">{{ item.ValSecRest }}</Col>
        <Col flex="1" class="table-cell" :style="colStyle('21')" v-show="showCol('21')">{{ item.DispRsv10 }}</Col>
        <Col flex="1" class="table-cell action-buttons flex-middle" :style="colStyle('22')" v-show="showCol('22')">
          <Button :type="successBtnClass(item)" size="small" icon="ios-eye-outline" @click.native="detail(item)"></Button>
          <Button v-if="item.AlarmCnt > 0" type="error" size="small" icon="ios-warning" @click.native="toWarning(item)"></Button>
        </Col>
      </Row>
    </CheckboxGroup>
      <Row type="flex" class="action-row menu-actions">
       
        <Col flex="1">
        <Page class="page-line" :total="total" :current="current" :page-size="pageSize" show-total
          @on-change="handlePageChange" @on-page-size-change="handlePageSizeChange" :show-sizer="true"
          :page-size-opts=pageSizeAry>{{ getTranslation('c010') }} {{ total }}
          {{ getTranslation('c011') }}</Page>
        </Col>
      </Row>
      <RecordDetail :record-id="detailItem" v-model="modalVisible" :propVisible="modalVisible" :allItem="allItem"
        @change-record="changeRecord"></RecordDetail>
        <RecordCol v-model="colShowVisible" :propVisible="colShowVisible" @record-col-change="initCol"></RecordCol>
    </div>
  </MainLayout>
</template>

<script>
import { API_URL, PAGE_SIZE_ARY } from '@/constants/const';
import MainLayout from '@/components/MainLayout.vue'
import axios from 'axios';
import { mapGetters,mapState } from 'vuex'
import { Row, Col, Button, Input, Select, Option, DatePicker, Page, Checkbox, CheckboxGroup, Affix, Tooltip } from "view-design"
import { formatUTCDate, formatShorTime, blobToString, exportFile, setSidbarBreadCrumb, postJsError, setDashboardPage } from '@/util/util.js'
import RecordDetail from './components/RecordDetail.vue'
import NoAuth from '@/components/NoAuth.vue'
import RecordCol from './components/RecordCol.vue';
export default {
  name: 'RecordIndex', // 组件名称
  components: {
    MainLayout, Row, Col, Button, DatePicker, Page, Input, Select, Option, Checkbox, CheckboxGroup, RecordDetail, NoAuth, Affix, Tooltip, RecordCol
  },
  watch: {

  },
  computed: {
    ...mapGetters(['getTranslation']),
    ...mapState(['queryDate']),
    WarnList() {
      return [
        this.getTranslation("k236"),
        this.getTranslation("k237"),
        this.getTranslation("k238"),
      ]
    }
  },
  data() {
    return {
      record: [],
      total: 0,
      current: 1,
      pageSize: parseInt(localStorage.getItem('user.page_size')) || 20,
      selectDate: [new Date(),new Date()],
      alarmOpt: 0,
      programId: '',
      recordId: '',
      selectedItems: [],
      detailItem: '',
      modalVisible: false,
      vin: '',
      pageSizeAry: PAGE_SIZE_ARY,
      hasAuth: true,
      allItem: [],
      selectedRecord: '',
      uipStart: '',
      uipEnd: '',
      spotId: '',
      mac: '',
      colWidths: {
      },
      resizing: null,
      colShowVisible: false,
      showColKeys: [],
    }
  },
  mounted() {    
  },
  created() {
    setDashboardPage('record');
    this.init();
  },
  methods: {
    init() {
      this.initCol();
      this.mac = this.$route.query.mac
      this.initMachine();

      this.$nextTick(() => {
        // initialize saved widths first, then collect header widths once
        this.loadColWidths();
        this.initHeaderWidths();
        let start = this.$route.query.start;
        let end = this.$route.query.end;
        let recordId = this.$route.query.record_id;
      
        if (start && end) {        
          this.selectDate = [new Date(start),new Date(end) ]
        } else if (this.queryDate && this.queryDate.length > 0) {
            this.selectDate = [...this.queryDate]
        }       
        if (recordId) {
          this.recordId = recordId
        }
        this.getData();
      })
    },
    initMachine() {
      let url = API_URL["recordInit"];
      let params = {
        mac: this.mac
      }     
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.$store.commit('setBreadcrumbItems', [
              { title: setSidbarBreadCrumb(res.data.data.machine), machine: res.data.data.machine }
            ]);
          }
        })
    },
    initCol(){
      const raw = localStorage.getItem('record.showCols');      
      if (raw) {
          try {
              const parsed = JSON.parse(raw);
              if (parsed && typeof parsed === 'object') {
                  this.showColKeys = parsed;
              }
          } catch (_) { /* ignore */ }
      }
    },
    // collect initial header widths once, avoid mutating during render
    initHeaderWidths() {
      for (let i = 1; i <= 22; i++) {
        const key = String(i);
        if (!this.colWidths[key]) {
          const ref = this.$refs[`col-ref-${key}`];
          if (ref && ref.$el) {
            this.$set(this.colWidths, key, ref.$el.clientWidth);
          }
        }
      }
    },
    getData() {
      let url = API_URL["recordGet"];
      if (!this.mac) {
        this.$Message.error(this.getTranslation('m041'));
        return
      }
      let params = {
        page: this.current,
        page_size: this.pageSize,
        mac: this.mac,
        start: formatUTCDate(this.selectDate[0]),
        end: formatUTCDate(this.selectDate[1]),
        program_id: this.programId == '' ? -1 : this.programId,
        alarm_opt: this.alarmOpt,
        vin: this.vin,
        record_id: this.recordId,
        uip_start: this.uipStart,
        uip_end: this.uipEnd,
        spot_id: this.spotId,
      }
      this.$store.commit('setQueryDate', this.selectDate)
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.record = res.data.data.data;
            this.total = res.data.data.total;
            this.pageSize = res.data.data.pagination.page_size;
            this.current = res.data.data.pagination.page;
          } else if (res && res.data && res.data.code == 3001) {
            this.hasAuth = false;
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    emptyRecordQuery(){
      this.current =1;
      this.alarmOpt = 0;
      this.programId = '' 
      this.vin=''
      this.recordId='';
      this.uipStart=''
      this.uipEnd=''
      this.getData();
    },
    queryData(){
      this.current =1;
      this.getData();
    },
    handlePageChange(page) {
      this.current = page;
      this.getData();
    },
    formatShorTime(str) {
      return formatShorTime(str)
    },
    handleCheckAll(status) {
      if (status) {
        this.selectedItems = this.record && this.record.map(item => this.uniqLabel(item));
      } else {
        this.selectedItems = [];
      }
    },

    deleteRecord() {
      if (this.selectedItems.length === 0) {
        this.$Message.error(this.getTranslation('b177'));
        return
      }

      this.$Modal.confirm({
        title: this.getTranslation('b135'),
        content: this.getTranslation('b180'),
        okText: this.getTranslation('m027'),
        cancelText: this.getTranslation('b182'),
        onOk: () => {
          let url = API_URL["recordDelete"];
          let ids = [];
          let tables = [];
          this.selectedItems.forEach(item => {
            let aryAll = item.split(",")
            tables.push(aryAll[0])
            ids.push(aryAll[1])
          })
          let formData = new FormData();
          formData.append('ids', ids);
          formData.append('tables', tables.join(","));

          axios.post(url,
            formData
          )
            .then(res => {
              if (res && res.data && res.data.code == 200) {
                this.selectedItems = []
                this.$Message.success(res.data.msg);
                this.getData();
              } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg);
              }
            })
            .catch((err) => {
              postJsError(err)
              this.$Message.error(this.getTranslation('c001'));
            })

        }
      });
    },

    async exportRecord() {
      let params = {
        mac: this.mac,
        start: formatUTCDate(this.selectDate[0]),
        end: formatUTCDate(this.selectDate[1]),
        program_id: this.programId == '' ? -1 : this.programId,
        alarm_opt: this.alarmOpt,
        vin: this.vin,
        record_id: this.recordId,
        uip_start: this.uipStart,
        uip_end: this.uipEnd,
      }
      let exportUrl = API_URL["recordExport"];
      const response = await axios.get(exportUrl, {
        responseType: 'blob',
        params: params,
        timeout:300000
      });
      if (response.status == 200) {
        const contentType = response.headers['content-type'];
        if (contentType && contentType.includes('application/json')) {
          blobToString(response.data).then(text => {
            let msgData = JSON.parse(text);
            if (msgData.msg) {
              this.$Message.error(msgData.msg)
            }
          }).catch((err) => {
            postJsError(err)
            this.$Message.error(this.getTranslation('c001'));
          });
        } else {
          exportFile(response)
        }
      } else {
        this.$Message.error(this.getTranslation('c001'));
      }


    },
    uniqLabel(item) {
      return item.TableId + ',' + item.Id
    },
    detail(item) {
      this.detailItem = this.uniqLabel(item);
      let AllItem = []
      this.record && this.record.forEach(item => {
        AllItem.push(this.uniqLabel(item))
      })
      this.allItem = AllItem
      this.modalVisible = true;
    },
    handlePageSizeChange(pageSize) {
      this.current = 1;
      this.pageSize = pageSize;
      localStorage.setItem('user.page_size', this.pageSize)
      this.getData();
    },
    changeRecord(record) {
      this.selectedRecord = record
    },
    successBtnClass(item) {
      let rs = "success"
      if (this.selectedRecord == this.uniqLabel(item)) {
        rs = "warning"
      }
      return rs
    },
    toWarning(item) {
      this.$router.push({
        path: '/alarm',
        query: {
          mac: this.mac,
          start: formatUTCDate(this.selectDate[0]),
          end: formatUTCDate(this.selectDate[1]),
          record_id: item.RecordId
        }
      })

    },
    showCol(key){
      if (!this.showColKeys || this.showColKeys.length ==0){
        return true;
      }
      return this.showColKeys.includes(key);
    },
    colStyle(key) {
      const w = this.getColWidth(key);
      const basis = w || 100;
      const isLast = key === '22';
      const style = {
        flex: isLast ? `0 0 ${basis}px` : `1 1 ${basis}px`,
        minWidth: '30px',
        position: 'relative'
      };
      if (isLast) style.marginLeft = 'auto';
      return style;
    },
    getColWidth(key) {
      // pure: do not mutate reactive state inside render
      const ref = this.$refs[`col-ref-${key}`];
      const current = this.colWidths[key];
      return current || (ref && ref.$el ? ref.$el.clientWidth : '');
    },
    startResize(key, e) {
      const startX = e.clientX;
      const startWidth = this.getColWidth(key);
      this.resizing = { key, startX, startWidth };
      window.addEventListener('mousemove', this.onResizeMouseMove);
      window.addEventListener('mouseup', this.stopResizeMouseMove);
      e.preventDefault();
    },
    onResizeMouseMove(e) {
      if (!this.resizing) return;
      const delta = e.clientX - this.resizing.startX;
      const newWidth = Math.max(60, this.resizing.startWidth + delta);
      this.$set(this.colWidths, this.resizing.key, newWidth);
    },
    stopResizeMouseMove() {
      if (!this.resizing) return;
      window.removeEventListener('mousemove', this.onResizeMouseMove);
      window.removeEventListener('mouseup', this.stopResizeMouseMove);
      this.saveColWidths();
      this.resizing = null;
    },
    loadColWidths() {
      try {
        const raw = localStorage.getItem('record.colWidths');
        if (raw) {
          const parsed = JSON.parse(raw);
          this.colWidths = { ...this.colWidths, ...parsed };
        }
      } catch (_) { console.log(_) }
    },
    saveColWidths() {
      try {
        localStorage.setItem('record.colWidths', JSON.stringify(this.colWidths));
      } catch (_) { console.log(_) }
    }
  }
}
</script>

<style>
.hide-label.ivu-checkbox-wrapper>span:last-child {
  display: none;
}
.ivu-checkbox+span, .ivu-checkbox-wrapper+span {
  margin-right: 0px !important;
}

</style>
<style scoped>
@import url('../../assets/style/list.css');
.col-resizer {
  position: absolute;
  right: 0px;
  top: 0;
  height: 100%;
  width: 1px;
  cursor: col-resize;
  user-select: none;
  /* subtle visual cue */
  background: rgba(0, 0, 0, 0.1);
}
</style>